<template>
  <div>
    <NotificationHistorySidebar
      v-if="show"
      :onModalClose="() => this.show = false"
    />
    <button @click="openBar" class="btn btn-outline-info btn-rounded bg-white">
      <i class="icon-fa icon-fa-history"></i>
    </button>
  </div>
</template>

<script>

import NotificationHistorySidebar from "@/components/modals/sideBars/NotificationHistorySidebar";

export default {
  components: {
    NotificationHistorySidebar
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    openBar() {
      this.show = true;
    },
  }
}

</script>

<style scoped>
.btn i {
  text-align: center;
}
</style>
